import React from 'react'
import { StyledToastContainer } from './styled'

const ToastContainer = props => <StyledToastContainer {...props} />

export default ToastContainer
